import filtersConfig from "../config/filtersConfig";
import MapService from "../services/MapService";

export default {
  setChartDateRange({ commit }, payload) {
    commit("setChartDateRange", payload);
  },
  setSelectedMaaleParameter({ commit }, payload) {
    commit("setSelectedMaaleParameter", payload);
  },
  setFromYear({ commit }, payload) {
    commit("setFromYear", payload);
  },
  setToYear({ commit }, payload) {
    commit("setToYear", payload);
  },
  setTimeSeriesCount({ commit }, payload) {
    commit("setTimeSeriesCount", payload);
  },
  setDefinitionExpression({ commit }, definitionExpression) {
    commit("setDefinitionExpression", definitionExpression);
  },
  /**
   * Oppdaterer filterverdien og håndterer spesiallogikk for "stasjonParameter"-filteret.
   * Dersom "stasjonParameter" oppdateres, oppdateres også mulige valg og gjeldende verdi for målested.
   * Kaller også updateQueryExpression for å oppdatere spørringsuttrykket.
   *
   * @param {Object} context - Vuex action context-objektet.
   * @param {Function} context.commit - Funksjon for å kommitte mutasjoner.
   * @param {Function} context.dispatch - Funksjon for å dispatch'e andre actions.
   * @param {Object} context.state - Gjeldende state for store.
   * @param {Object} filterValue - Objekt som inneholder informasjon om filteret som skal oppdateres.
   * @param {string} filterValue.filterFieldName - Navnet på filterfeltet som oppdateres.
   * @param {string|null} filterValue.filterQueryString - Query string for filteret.
   */
  setFilterValue({ commit, dispatch, state }, filterValue) {
    commit("setFilterValue", filterValue);
    if (filterValue.filterFieldName === "stasjonParameter") {
      // Dersom filteret som oppdateres er stasjonParameter,
      // må vi oppdatere mulige valg i nedtrekkslisten for målested
      // og eventuelt oppdatere gjeldende verdi for målested
      // dersom det er valgt en verdi i nedtrekkslisten som ikke er med i de unike verdiene.
      MapService.updateUniqueFilter(
        state.filters[0].filters[1],
        filterValue.filterQueryString,
        state.filters[0]
      ).then((uniqueValues) => {
        let newItems;
        if (uniqueValues[0].options.length === 0) {
          newItems = [uniqueValues[1]];
        } else {
          newItems = uniqueValues;
        }
        commit("updateMaaleStedValues", newItems);

        if (filterValue.filterQueryString !== null) {
          // Sjekk om målested valgte verdier inneholder verdier som er med i uniquevalues. Verdier som er med begge steder skal ikke fjernes.
          let maalestedSelectedValues =
            state.filters[0].filters[1].currentValue;
          let newValue = [];
          if (typeof maalestedSelectedValues !== "undefined") {
            for (let i = 0; i < maalestedSelectedValues.length; i++) {
              let selectedValue = maalestedSelectedValues[i];
              if (
                uniqueValues[0].options.includes(selectedValue) ||
                uniqueValues[1].options.includes(selectedValue)
              ) {
                newValue.push(selectedValue);
              }
            }
          }

          commit("updateMaaleStedCurrentValue", newValue);
        }
      });
    }
    dispatch("updateQueryExpression");
  },
  setActiveGeographicFilterMode({ commit }, activeGeographicFilterMode) {
    commit("setActiveGeographicFilterMode", activeGeographicFilterMode);
  },
  setCurrentMapExtent({ commit }, newMapExtent) {
    commit("setCurrentMapExtent", newMapExtent);
  },
  setUseMapExtent({ commit }, useMapExtent) {
    commit("setUseMapExtent", useMapExtent);
  },
  setSelectedBasemap({ commit }, basemap) {
    commit("setSelectedBasemap", basemap);
  },
  setShowInfoDrawer({ commit }, payload) {
    commit("setShowInfoDrawer", payload);
  },
  setSplitSize({ commit }, payload) {
    commit("setSplitSize", payload);
  },
  setActiveInfoDrawerTab({ commit }, payload) {
    commit("setActiveInfoDrawerTab", payload);
  },

  /**
   * Oppdaterer visningen av stasjoner fra andre aktører og filtrerer ut relevante måleparametere.
   *
   * Hvis `showStationsFromOtherActors` er falsk, fjernes spesifikke måleparametere fra det valgte filteret.
   * Oppdaterer deretter tilstanden for å vise eller skjule stasjoner fra andre aktører.
   *
   * @param {Object} context - Vuex context-objektet, inneholder commit og state.
   * @param {Function} context.commit - Metode for å commite mutasjoner.
   * @param {Object} context.state - Gjeldende tilstand i store.
   * @param {boolean} showStationsFromOtherActors - Angir om stasjoner fra andre aktører skal vises.
   */
  setShowStationsFromOtherActors(
    { commit, state },
    showStationsFromOtherActors
  ) {
    let stationsFromOtherActorsStasjonParameterValues = [
      "Grunnvannsnivå - dyp under bakken",
      "Vindstyrke",
      "Temperatur",
      "Nysnødybde",
    ];
    if (!showStationsFromOtherActors) {
      // Hvis stasjoner fra andre aktører ikke skal vises, fjern de spesifikke måleparametrene fra
      // nedtrekkslisten for måleparametre.
      if (state.filters[0].filters[0].currentValue) {
        let maaleParameterNewValue = state.filters[0].filters[0].currentValue.filter(
          (i) => !stationsFromOtherActorsStasjonParameterValues.includes(i)
        );
        commit("setSelectedMaaleParameter", maaleParameterNewValue);
        commit("updateMaaleParameterCurrentValue", maaleParameterNewValue);
      }
    }
    commit("setShowStationsFromOtherActors", showStationsFromOtherActors);
  },
  /**
   * Oppdaterer de valgte kolonnene i tabellen.
   * Hvis kolonnen "data-table-expand" finnes, flyttes den til slutten av listen.
   *
   * @param {Object} context - Vuex context-objektet, inneholder commit-metoden.
   * @param {Function} context.commit - Metode for å kommitte mutasjoner.
   * @param {Array<Object>} payload - Listen over valgte kolonner.
   */
  setSelectedColumns({ commit }, payload) {
    let expandColumnIndex = payload.findIndex((item) => {
      return item.value === "data-table-expand";
    });
    if (expandColumnIndex > -1) {
      payload.splice(expandColumnIndex, 1);
      payload.push({ text: "", value: "data-table-expand" });
    }
    commit("setSelectedColumns", payload);
  },
  setSelectedTimeSeries({ commit }, payload) {
    commit("setSelectedTimeSeries", payload);
  },
  setBufferSettings({ commit }, payload) {
    commit("setBufferSettings", payload);
  },
  setSelectedTimeSeriesOtherActors({ commit }, payload) {
    commit("setSelectedTimeSeriesOtherActors", payload);
  },
  setClickedTimeSeries({ commit }, payload) {
    commit("setClickedTimeSeries", payload);
  },
  setShowPopups({ commit }, payload) {
    commit("setShowPopups", payload);
  },
  setShowSelectFeatureDialog({ commit }, payload) {
    commit("setShowSelectFeatureDialog", payload);
  },
  setSelectedColumnsOtherActors({ commit }, payload) {
    commit("setSelectedColumnsOtherActors", payload);
  },
  setMainLayerSymbolSettings({ commit }, payload) {
    commit("setMainLayerSymbolSettings", payload);
  },
  setActiveTableTab({ commit }, payload) {
    commit("setActiveTableTab", payload);
  },
  setHideWelcomeMessageInFilterDrawer({ commit }, payload) {
    commit("setHideWelcomeMessageInFilterDrawer", payload);
  },
  setShowFilterPanel({ commit }, payload) {
    commit("setShowFilterPanel", payload);
  },
  /**
   * Setter standardaltnerativer for filter ved å hente unike verdier og min/maks verdier for hvert filter.
   *
   * Itererer gjennom alle filterkonfigurasjoner og oppdaterer filterverdier ved å hente nødvendige data
   * fra MapService. Når alle asynkrone operasjoner er fullført, oppdateres filterne i state.
   *
   * @param {Object} context - Vuex context-objektet, forventer at `commit`-metoden er tilgjengelig.
   * @param {Function} context.commit - Funksjon for å commite mutasjoner til store.
   */
  setFilterDefaultValues({ commit }) {
    let whereQuery = "1=1";

    let promises = [];

    for (let i = 0; i < filtersConfig.filters.length; i++) {
      let filterCategory = filtersConfig.filters[i];
      if (Object.prototype.hasOwnProperty.call(filterCategory, "filters")) {
        for (let j = 0; j < filterCategory.filters.length; j++) {
          let filter = filterCategory.filters[j];

          if (filter.fetch == "unique") {
            promises.push(
              new Promise((resolve) => {
                MapService.updateUniqueFilter(
                  filter,
                  whereQuery,
                  filterCategory
                ).then((uniqueValues) => {
                  filter.values = uniqueValues;

                  resolve(true);
                });
              })
            );
          }

          if (filter.fetch == "minmax") {
            promises.push(
              new Promise((resolve) => {
                MapService.updateMinMaxFilter(filter, whereQuery).then(
                  (minMaxValues) => {
                    filter.options.min = minMaxValues.min;
                    filter.options.max = minMaxValues.max;

                    resolve(true);
                  }
                );
              })
            );
          }
        }
      }
    }

    Promise.all(promises).then(() => {
      commit("setFilters", filtersConfig.filters);
      commit("setFiltersAreLoading", false);
    });
  },
  /**
   * Oppdaterer spørringsuttrykkene som brukes most karttjenestene for å filtrere hvilke
   * tidsserier som vises basert på gjeldende filterverdier i state.
   * Bygger to uttrykk: ett for standard spørring og ett for stasjoner fra andre aktører.
   * Setter de genererte uttrykkene i state via commit-metoder.
   *
   * @param {Object} context - Vuex context-objektet.
   * @param {Function} context.commit - Funksjon for å commite mutasjoner.
   * @param {Object} context.state - Gjeldende state, inneholder filterverdier og filterdefinisjoner.
   */
  updateQueryExpression({ commit, state }) {
    let newDefinitionExpression;
    let newQueryExpressionStationsFromOtherActors =
      "DATA_EIER_KATEGORI <> 'NVE' AND PARAMETERNAVN IN ('Nedbør', 'Temperatur', 'Snødybde')";

    for (var property in state.filterValues) {
      if (
        Object.prototype.hasOwnProperty.call(state.filterValues, property) &&
        state.filterValues[property] !== null
      ) {
        if (newDefinitionExpression) {
          newDefinitionExpression =
            newDefinitionExpression + " AND " + state.filterValues[property];
        } else {
          newDefinitionExpression = state.filterValues[property];
        }

        let match = state.filtersStationsFromOtherActors.filter((e) =>
          e.matchFields.includes(property)
        );

        if (match.length > 0) {
          let expression;
          let fields = match[0].fields;
          let matchFields = match[0].matchFields;

          for (let i = 0; i < fields.length; i++) {
            let fieldName = fields[i];
            let matchFieldName = matchFields[i];

            if (expression) {
              expression = expression.replaceAll(matchFieldName, fieldName);
            } else {
              expression = state.filterValues[property].replaceAll(
                matchFieldName,
                fieldName
              );
            }
          }

          if (newQueryExpressionStationsFromOtherActors) {
            if (expression.includes("Lufttemperatur")) {
              expression = expression.replace("Lufttemperatur", "Temperatur");
            }
            newQueryExpressionStationsFromOtherActors =
              newQueryExpressionStationsFromOtherActors + " AND " + expression;
          }
        }
      }
    }
    let queryExpression = newDefinitionExpression
      ? newDefinitionExpression
      : "1=1";
    let queryExpressionStationsFromOtherActors = newQueryExpressionStationsFromOtherActors
      ? newQueryExpressionStationsFromOtherActors
      : "DATA_EIER_KATEGORI <> 'NVE' AND PARAMETERNAVN IN ('Nedbør', 'Temperatur', 'Snødybde')";

    commit("setQueryExpression", queryExpression);
    commit(
      "setQueryExpressionStationsFromOtherActors",
      queryExpressionStationsFromOtherActors
    );
  },
  setYearFilterMode({ commit }, payload) {
    commit("setYearFilterMode", payload);
  },
  setMapHasLoaded({ commit }, payload) {
    commit("setMapHasLoaded", payload);
  },
};
